import { Component } from '@angular/core';
import { AppApi } from './app.api';
import { AppState } from 'src/app/app.state';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'angular-app';
  env: any;
  identityToken: any;

  constructor(
    public appApi: AppApi,
    public appState: AppState,
    public cookieService: CookieService
  ) {}

  ngOnInit(): void {
    this.env = environment.env_name;
    this.appState.companyInfoValue = this.appState.companyInfoValue || {};
    this.appApi.getCompany().subscribe({
      next: (res) => {
        if (res && res.data) {
          this.appState.companyInfoValue = res.data;
        } else {
          console.log('else getCompany res : ', res);
        }
      },
      error: (err) => {
        console.log('app getCompany err : ', err);
      },
    });
  }
}
